export default __webpack_public_path__ + "static/media/modely7.b30bc775.jfif";